import type { EditorView } from '@atlaskit/editor-prosemirror/view';

import { pluginKey } from '../../common/agentManagedExtensionPluginType';
import { findAgentManagedExtension } from '../../common/utils';

import { setMeta } from './state';

interface AutoOpenView {
	update: () => void;
}

/**
 * Watches for newly-inserted agent-managed extensions and dispatches
 * `OPEN_CONFIG` when the cursor lands inside the new block. Only
 * triggers for genuine user insertions — not on initial document load,
 * document replacement, or remote/collab operations.
 *
 * Returns the `view` object expected by the ProseMirror plugin spec.
 */
export const createAutoOpenConfigOnInsertView = (editorView: EditorView): AutoOpenView => {
	const handledLocalIds = new Set<string>();

	return {
		update() {
			const pendingLocalId = pluginKey.getState(editorView.state)?.pendingAutoOpenLocalId;
			if (!pendingLocalId || handledLocalIds.has(pendingLocalId)) {
				return;
			}

			const found = findAgentManagedExtension(editorView.state);
			if (found?.node.attrs.localId !== pendingLocalId) {
				return;
			}
			handledLocalIds.add(pendingLocalId);
			editorView.dispatch(setMeta(editorView.state.tr, { type: 'OPEN_CONFIG' }));
		},
	};
};
